module.exports = __webpack_public_path__ + "static/media/3.86147cc1.png";